/**
 * Remembers that the API rejected a request with 403 LICENSE_REQUIRED (the
 * signed-in user has no active licence — e.g. their free beta licence expired
 * or was revoked). apiClient marks it; LicenseRequiredNotice (rendered by
 * AppLayout on every page) subscribes and explains the situation instead of
 * leaving the user with an untranslated error. The flag lasts for the page
 * session: a licence granted later takes effect after a reload.
 */
type Listener = () => void;

let licenseRequired = false;
const listeners = new Set<Listener>();

export const LICENSE_REQUIRED_CODE = 'LICENSE_REQUIRED';

export function markLicenseRequired(): void {
  if (licenseRequired) return;
  licenseRequired = true;
  listeners.forEach((listener) => listener());
}

export function isLicenseRequired(): boolean {
  return licenseRequired;
}

export function subscribeLicenseRequired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Forget the flag (sign-out / account switch: the next user has their own licence). */
export function clearLicenseRequired(): void {
  if (!licenseRequired) return;
  licenseRequired = false;
  listeners.forEach((listener) => listener());
}

/** Test-only: forget the flag. */
export function resetLicenseRequiredForTests(): void {
  licenseRequired = false;
  listeners.forEach((listener) => listener());
}
